<template>
  <div id="app">
    <nav class="navbar navbar-light bg-light">
      <a class="navbar-brand" href='#/'>
        <img src="./assets/logo.jpg" width="30" height="30" alt>      
      </a>
      
    </nav>
    <router-view></router-view>
  </div>
</template>

<script>

import Vue from "vue";

// Font Awesome Free
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

// Router
import router from "./router/index.js";

import Register from './components/Register.vue'

export default {
  name: 'app',
  components: {
    Register
  },
  router:router
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
